import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CODIGO' htmlFor='input-codigo' xs={12} />
      <Col xs={12}>
        <Form.InputText defaultValue={iValue} disabled id='input-codigo' name='codigo' />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
